export default __webpack_public_path__ + "static/media/gallery.37a27191.jpg";